module.exports = __webpack_public_path__ + "static/img/a1.08aee758.png";